<div
  class="completion-box"
  [class.highlight]="highlight"
  fxLayout
  fxLayoutGap="12px"
  fxLayoutAlign="start center"
  fxLayout.lt-md="column"
  fxLayoutAlign.lt-md="start stretch">
  <div fxFlex fxLayout="column" fxLayoutGap="4px">
    <span class="text__medium night-darker">{{ heading }}</span>
    <span class="text__small">{{ description }}</span>
  </div>
  <div [ngClass.gt-sm]="{ 'button-container': true }">
    <button mat-flat-button class="button__secondary fw">
      {{ buttonLabel }}
    </button>
  </div>
</div>
